import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import PdpSharedDetailMeasurement from './helpers/PdpSharedDetailMeasurement';

// helpers
import get from 'lodash.get';

function PdpSharedDetailLength({ item }) {
    return (
        <PdpSharedDetailMeasurement
            dataTn="pdp-spec-length"
            measurements={get(item, 'measurement.length')}
        />
    );
}

PdpSharedDetailLength.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailLength, {
    item: graphql`
        fragment PdpSharedDetailLength_item on Item {
            measurement {
                length: display(fields: [length]) {
                    ...PdpSharedDetailMeasurement_measurements
                }
            }
        }
    `,
});
